import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { TNewbuildingEntryBannerType } from '../../../types/newbuildingEntryBanner';
import * as styles from './NewbuildingEntryBanner.css';
import { BUTTON_THEME_MAP, CLASSES_THEME_MAP } from './constants';

export interface INewbuildingEntryBannerProps {
  onClick?(): void;
  onShow?(): void;
  url: string;
  title: string;
  description: string;
  type: TNewbuildingEntryBannerType;
}

export function NewbuildingEntryBanner({
  onClick,
  onShow,
  url,
  title,
  description,
  type,
}: INewbuildingEntryBannerProps) {
  const handleShow = React.useCallback(() => {
    if (onShow) {
      onShow();
    }
  }, [onShow]);

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.8} triggerOnce>
      <a className={classNames(styles['container'], CLASSES_THEME_MAP.get(type))} onClick={onClick} href={url}>
        <span className={styles['title']}>{title}</span>
        <span className={styles['description']}>{description}</span>
        <div className={styles['button']}>
          <Button size="M" theme={BUTTON_THEME_MAP.get(type)}>
            Смотреть предложения
          </Button>
        </div>
      </a>
    </ActionAfterViewObserver>
  );
}
